import { id, root } from './web-encoder-profiles';

export const webEncoderProfiles = {
  ...root,
  id: {
    ...id,
  },
};
